import PeopleInJourneyTable from "./PeopleInJourneyTable";

export default PeopleInJourneyTable;
